import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { PowerOutlinedIcon, AddIcon } from 'icons/materialIcons';
import TeamWhiteButtonWithIcon from 'team/shared/components/button/TeamWhiteButtonWithIcon';
import TeamDarkButtonWithIcon from 'team/shared/components/button/TeamDarkButtonWithIcon';

const TeamEmailSignatureNavbar = ({ templatesCount, onSetUpEmailSignature, onCreateEmailSignature }) => {
    return (
        <Box sx={{ padding: '1rem' }}>
            <Grid container spacing={2} alignItems="center" sx={{ marginBottom: '1rem' }}>
                {/* Left Side - Title */}
                <Grid item xs={12} sm="auto">
                    <Typography variant="h6" sx={{ fontWeight: 500 }}>
                        Email Signature Templates{' '}
                        <Typography component="span" variant="body2" sx={{ fontWeight: 400, color: '#757575' }}>
                            ({templatesCount})
                        </Typography>
                    </Typography>
                </Grid>

                {/* Right Side - Action Buttons */}
                <Grid item xs={12} sm container justifyContent="flex-end">
                    <Grid container spacing={1} justifyContent="flex-end">
                        {/* Set Up Email Signature Button (White) */}
                        <Grid item>
                            <TeamWhiteButtonWithIcon
                                text="Set Up Email signature"
                                icon={PowerOutlinedIcon}
                                onClick={onSetUpEmailSignature}
                                iconPosition="start"
                                sx={{
                                    fontWeight: 700
                                }}
                            />
                        </Grid>

                        {/* Create Email Signature Button (Dark) */}
                        <Grid item>
                            <TeamDarkButtonWithIcon
                                text="Create email signature"
                                icon={<AddIcon />}
                                onClick={onCreateEmailSignature}
                                iconPosition="start"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TeamEmailSignatureNavbar;

